import React from "react"
export function PlusOneBaggage(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M11.38 2c.646 0 1.179.492 1.243 1.123l.006.128v3.245h.872c.647 0 1.18.492 1.243 1.123l.007.128v9.007A1.25 1.25 0 0113.628 18l-.127.006h-.493V19h-1v-.995h-4.01v.993h-1v-.993H6.5a1.25 1.25 0 01-1.244-1.123l-.006-.128V7.747c0-.648.492-1.18 1.122-1.244l.128-.007h.878V3.251c0-.648.492-1.18 1.122-1.245L8.63 2h2.75zm2.37 9.494h-7.5v5.26a.25.25 0 00.193.244l.058.007h7a.25.25 0 00.243-.193l.007-.058v-5.26zM7.38 7.496l-.878.001a.25.25 0 00-.244.193l-.006.057v2.746h7.5V7.747a.25.25 0 00-.193-.243l-.057-.007-.872-.001v.008H7.38v-.008zm4-4.495H8.63a.25.25 0 00-.243.193l-.007.057v3.245h3.25V3.251a.25.25 0 00-.13-.22l-.063-.024-.057-.006z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__+1-baggage"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
